import type { IntegrationDocData } from './integrationDocData';

export const buildIntegrationCurls = (data: IntegrationDocData): string => {
  const api = `${data.testApiBase ?? data.prodApiBase}/business/integration`;
  const integrationHeaders = [
    '  -H "Authorization: Bearer $TOKEN" \\',
    `  -H "x-api-key: ${data.apiKey}" \\`,
    `  -H "x-api-secret: ${data.apiSecret}" \\`,
  ].join('\n');

  return `# 1. Login: copiá el accessToken de la respuesta
curl -X POST "${data.loginUrl}" \\
  -H "Content-Type: application/json" \\
  -d '{ "username": "${data.email}", "password": "${data.password}" }'

export TOKEN="<accessToken>"

# 2. Configuración
curl "${api}/config?commerceCode=${data.commerceCode}&logisticOperatorCode=${data.operatorCode}" \\
${integrationHeaders.replace(/ \\$/, '')}

# 3. Crear envío
curl -X POST "${api}/shipping" \\
${integrationHeaders}
  -H "Content-Type: application/json" \\
  -d '{
    "recipient": "Cliente prueba",
    "commerceShippingNumber": "PRUEBA-001",
    "logisticOperatorCode": "${data.operatorCode}",
    "commerceCode": "${data.commerceCode}",
    "externalBranchCode": "${data.defaultBranch.code}",
    "commercialServiceCode": "${data.defaultServiceCode}",
    "destinationCountryName": "${data.country}",
    "destinationStateOrDepartmentName": "${data.destination.state}",
    "destinationCityName": "${data.destination.city}",
    "destinationStreetName": "${data.destination.street}",
    "destinationDoorNumber": "1234"
  }'

# 4. Historial
curl "${api}/shipping/PRUEBA-001/historial" \\
${integrationHeaders.replace(/ \\$/, '')}
`;
};

const environmentsText = (data: IntegrationDocData): string =>
  data.testApiBase
    ? `Las credenciales sirven tanto en test como en producción; lo único que cambia es la URL base:
- Test: ${data.testApiBase}
- Producción: ${data.prodApiBase}`
    : `La URL base es ${data.prodApiBase}.`;

export const buildWebhookNoticeText = (
  commerceName: string,
  url: string,
  statusNames: string[]
): string =>
  `Buenos días,

Les confirmamos que ya está activo el aviso de cambios de estado de ${commerceName}.

- URL: ${url}
- Estados: ${statusNames.join(', ')}

Si les parece, podemos realizar una prueba en conjunto con un pedido para verificar que los avisos les lleguen bien.

Saludos,`;

export const buildIntegrationMailText = (data: IntegrationDocData): string =>
  `Buenos días,

Les enviamos adjunta la documentación de la API para ${data.commerceName}, con las credenciales de integración.

${environmentsText(data)}

Quedamos a disposición por cualquier consulta.

Saludos,`;
